export default "__VITE_ASSET__Cw3KrGVs__"